/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { useState } from "react";
import { generateUUID } from "common/utils/uuid";

const DEFAULT_DURATION_MS = 5000;
const MAX_VISIBLE_TOASTS = 5;

// eslint-disable-next-line import/prefer-default-export
export function usePinningToast() {
  const [toasts, setToasts] = useState([]);

  function addToast({
    title,
    description,
    variant = "default",
    duration = DEFAULT_DURATION_MS
  }: any) {
    const id = generateUUID();

    // @ts-expect-error TS(2345): Argument of type '(prev: never[]) => { id: string;... Remove this comment to see the full error message
    setToasts(prev => [
      ...prev.slice(-(MAX_VISIBLE_TOASTS - 1)),
      { id, title, description, variant, removing: false }
    ]);

    if (duration > 0) {
      setTimeout(() => dismissToast(id), duration);
    }

    return id;
  }

  function dismissToast(id: any) {
    // @ts-expect-error TS(2345): Argument of type '(prev: never[]) => any[]' is not... Remove this comment to see the full error message
    setToasts(prev => prev.map(t => (t.id === id ? { ...t, removing: true } : t)));

    // Remove from DOM after exit animation
    setTimeout(() => {
      // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
      setToasts(prev => prev.filter(t => t.id !== id));
    }, 300);
  }

  function clearAll() {
    setToasts([]);
  }

  return {
    toasts,
    dismiss: dismissToast,
    clearAll,
    toast: (props: any) => addToast(props),
    success: (props: any) => addToast({ ...props, variant: "success" }),
    error: (props: any) => addToast({ ...props, variant: "error" }),
    warning: (props: any) => addToast({ ...props, variant: "warning" }),
    info: (props: any) => addToast({ ...props, variant: "info" })
  };
}
